export default __webpack_public_path__ + "static/media/baseball-player-image.5af0e23f.jpeg";